import Sentry from "./sentry";
import { appInDevMode } from "../utils/helpers";

export const appGlobalErrorsHandler = ( useNotifications ) => {
    return (error, instance, info) => {
        if(appInDevMode()) {
            const notificationsStore = useNotifications()
            
            notificationsStore.notify(`Error: ${error.message} - Info: ${info}`, 'error')
        }else{
            Sentry.withScope((scope) => {
                // add aditional info
                scope.setTag('handler', 'vue.config.errorHandler')
                scope.setExtra('info', info)
                scope.setExtra('instance', instance)

                // catch error with sentry
                Sentry.captureException(error)
            })
        }
    }
}

export const appGlobalWarningsHandler = ( useNotifications ) => {
    return (message, instance, info) => {
        if(appInDevMode()) {
            const notificationsStore = useNotifications()
            
            notificationsStore.notify(`Warning: ${message} - Info: ${info}`, 'warning')
            console.warn(message)
        }
    }
}
